import React, { useState,useEffect } from "react";
import axios from 'axios';

import Select from "react-select";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    // alternateMobile: "",
    gender: "",
    type: "",
    category: [], // For multi-select categories
    isEducation: "",
    education:"",
    experience: "",
    email: "",
    doorNumber: "",
    street: "",
    place: "",
    district: "",
    city: "",
    pincode: "",
    otherDetails: "",
    webLinks: "",
    youtubeLinks: "",
    facebookLinks: "",
    dnd: "",
    image1: "",
    image2: "",
    idProof: "",
    addressProof: "",
    otherProof: "",
  });


  const [categories, setCategories] = useState([]); // For dropdown options
  const [districts, setDistricts] = useState([]);
const [cities, setCities] = useState([]);



    // Fetch categories from the backend
    useEffect(() => {
      const fetchCategoriesByType = async () => {
          if (!formData.type) {
              setCategories([]); // Clear categories if type is not selected
              return;
          }
          try {
              // const response = await fetch(`http://localhost:3036/categories?type=${formData.type}`);
              const response = await fetch(`${API_BASE_URL}/categories?type=${formData.type}`);


              if (response.ok) {
                  const data = await response.json();
                  const options = data.map((item) => ({
                      value: item.id,
                      label: item.category,
                  }));
                  setCategories(options);
              } else {
                  console.error("Failed to fetch categories");
              }
          } catch (err) {
              console.error("Error fetching categories:", err);
          }
      };

      fetchCategoriesByType();
  }, [formData.type]);
  





  useEffect(() => {
    const fetchDistricts = async () => {
        try {
            // const response = await fetch("http://localhost:3036/districts");
            const response = await fetch(`${API_BASE_URL}/districts`);


            if (response.ok) {
                const data = await response.json();
                setDistricts(data);
            } else {
                console.error("Failed to fetch districts");
            }
        } catch (err) {
            console.error("Error fetching districts:", err);
        }
    };
    fetchDistricts();
}, []);




  const handleCategoryChange = (selectedOptions) => {
    setFormData({
        ...formData,
        category: selectedOptions.map((option) => option.value).join(","), // Store as comma-separated IDs
    });
};


const handleDistrictChange = async (e) => {
  const districtId = e.target.value;
  setFormData({ ...formData, district: districtId, city: "" }); // Reset city
  try {
      const response = await fetch(`${API_BASE_URL}/cities?districtId=${districtId}`);
      if (response.ok) {
          const data = await response.json();
          setCities(data); // Keep the response format { id, tamil }
      } else {
          console.error("Failed to fetch cities");
      }
  } catch (err) {
      console.error("Error fetching cities:", err);
  }
};




  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const { mobile, type } = formData;

    if (!mobile || !type) {
        alert("Please enter both mobile number and type to search");
        return;
    }

    try {
        const response = await fetch(`${API_BASE_URL}/search`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ mobile, type }),
        });

        if (response.ok) {
            const result = await response.json();

            setFormData((prev) => ({
                ...prev,
                ...result,
                city: result.city === "0" ? "Nil" : result.city,
                image1: result.image1 || "",
                image2: result.image2 || "",
                idProof: result.idproof || "",
                addressProof: result.addressproof || "",
                otherProof: result.otherproof || "",
                isEducation: result.isEducation === null ? "0" : result.isEducation.toString(), // Convert to string
            }));

            if (result.district) {
                const districtId = result.district;
                const citiesResponse = await fetch(`${API_BASE_URL}/cities?districtId=${districtId}`);
                if (citiesResponse.ok) {
                    const citiesData = await citiesResponse.json();
                    setCities(citiesData);
                } else {
                    console.error("Failed to fetch cities");
                }
            }
            alert("User data fetched successfully");
        } else {
            const error = await response.json();
            alert(error.error || "Failed to fetch user data");
        }
    } catch (err) {
        console.error("Error fetching user data:", err);
        alert("An error occurred while searching for user data");
    }
};


  


      useEffect(() => {
            document.title = 'Registration - Calendar Services';
          }, []);
    




  const handleFileChange = (e) => {
    const { name } = e.target;
    setFormData({ ...formData, [name]: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        // const response = await fetch("http://localhost:3036/register", {
          const response = await fetch(`${API_BASE_URL}/register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        });
        if (response.ok) {
            const result = await response.json();
            alert(`User registered successfully! User ID: ${result.id}`);
            window.location.reload(); // Refresh the page after successful save
        } else {
            const error = await response.json();
            alert(`Failed to register user: ${error.error}`);
        }
    } catch (err) {
        console.error("Error submitting form:", err);
        alert("An error occurred. Please try again.");
    }
};



  return (
    
    <div className="max-w-5xl mx-auto p-3">
          <div className="max-w-6xl mx-auto mt-9 px-4 py-2 bg-blue-900  shadow-md rounded mb-8">

    <h1 className="text-2xl font-bold text-white mb-5">Search Form</h1>
    
    {/* Additional Section Above the Form */}
    <div className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-black">
        <div>
          <label className="block font-semibold mb-1 text-white">Mobile No<span className="text-red-500">*</span></label>
          <input
            type="text"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            className="w-full border rounded p-2"
            required
          />
        </div>
        <div>
          <label className="block font-semibold mb-1 text-white">Type<span className="text-red-500">*</span></label>
          <select
            name="type"
            value={formData.type}
            onChange={handleChange}
            className="w-full border rounded p-2"
            required
          >
            <option value="">Select Type</option>
            <option value="ஜோதிடர்">ஜோதிடர்</option>
            <option value="ஐயர்">ஐயர்</option>
            <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
            <option value="எண்கணிதம்">எண்கணிதம்</option>
            <option value="சிற்பி">சிற்பி</option>
            <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
            <option value="ஆன்மீக சொற்பொழிவாளர்">ஆன்மீக சொற்பொழிவாளர்</option>
            <option value="திருவிழா அலங்காரம் செய்பவர்">
              திருவிழா அலங்காரம் செய்பவர்
            </option>
            <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
            <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
          </select>

          {/* Add other file upload fields in a similar manner */}
<div className="mt-6 flex justify-end">
<button
  type="button"
  onClick={handleSearch}
  className="bg-blue-600 text-white px-4 py-2 rounded"
>
  Search
</button>

</div>

        </div>
      </div>
    </div>
    </div>
    
      <h1 className="text-2xl font-bold text-blue-600 mb-6">Registration Form</h1>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block font-semibold mb-1">Name<span className="text-red-500">*</span></label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full border rounded p-2"
              required
            />
          </div>
          <div>
            <label className="block font-semibold mb-1">Mobile No<span className="text-red-500">*</span></label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              className="w-full border rounded p-2"
              required
            />
          </div>
          {/* <div>
            <label className="block font-semibold mb-1">Alternate Mobile No</label>
            <input
              type="text"
              name="alternateMobile"
              value={formData.altermobile}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div> */}
    <div>
  <label className="block font-semibold mb-1">Gender<span className="text-red-500">*</span></label>
  <div className="flex gap-4">
    <label>
      <input
        type="radio"
        name="gender"
        value="ஆண்"
        onChange={handleChange}
        checked={formData.gender === "ஆண்"}
        required
      />
      ஆண்
    </label>
    <label>
      <input
        type="radio"
        name="gender"
        value="பெண்"
        onChange={handleChange}
        checked={formData.gender === "பெண்"}
        required
      />
      பெண்
    </label>
  </div>
</div>

          <div>
            <label className="block font-semibold mb-1">Type<span className="text-red-500">*</span></label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              className="w-full border rounded p-2"
              required
            >
               <option value="">Select Type</option>
            <option value="ஜோதிடர்">ஜோதிடர்</option>
            <option value="ஐயர்">ஐயர்</option>
            <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
            <option value="எண்கணிதம்">எண்கணிதம்</option>
            <option value="சிற்பி">சிற்பி</option>
            <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
            <option value="ஆன்மீக சொற்பொழிவாளர்">ஆன்மீக சொற்பொழிவாளர்</option>
            <option value="திருவிழா அலங்காரம் செய்பவர்">
              திருவிழா அலங்காரம் செய்பவர்
            </option>
            <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
            <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
          
            </select>
          </div>
          <div>
          <label className="block font-semibold mb-1">Category<span className="text-red-500">*</span></label>
          <Select
    isMulti
    options={categories}
    value={categories.filter((cat) => formData.category.includes(cat.value))}
    onChange={handleCategoryChange}
    className="w-full text-black"
    placeholder="Select categories"
/>

            
          </div>
          <div>
  <label className="block font-semibold mb-1">Is Education</label>
  <div className="flex gap-4">
    <label>
      <input
        type="radio"
        name="isEducation"
        value="1"
        onChange={handleChange}
        checked={formData.isEducation === "1"} // Yes is selected when isEducation === "1"
      />
      Yes
    </label>
    <label>
      <input
        type="radio"
        name="isEducation"
        value="2"
        onChange={handleChange}
        checked={formData.isEducation === "2"} // No is selected when isEducation === "2"
      />
      No
    </label>
  </div>
</div>


          <div>
            <label className="block font-semibold mb-1">Education</label>
            <input
              type="text"
              name="education"
              value={formData.education}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
          <div>
            <label className="block font-semibold mb-1">Experience<span className="text-red-500">*</span></label>
            <input
              type="text"
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              className="w-full border rounded p-2"
              required
            />
          </div>
          <div>
            <label className="block font-semibold mb-1">E-mail</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
          <div>
            <label className="block font-semibold mb-1">Door Number</label>
            <input
              type="text"
              name="doorNumber"
              value={formData.doorNumber}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
          <div>
            <label className="block font-semibold mb-1">Street</label>
            <input
              type="text"
              name="street"
              value={formData.street}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
          <div>
            <label className="block font-semibold mb-1">Place</label>
            <input
              type="text"
              name="place"
              value={formData.place}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
          <div>
    <label className="block font-semibold mb-1">District<span className="text-red-500">*</span></label>
    <select
    name="district"
    value={formData.district}
    onChange={handleDistrictChange}
    className="w-full border rounded p-2"
    required
>
    <option value="">Select District</option>
    {districts.map((district) => (
        <option key={district.id} value={district.id}>
            {district.tamil}
        </option>
    ))}
</select>

</div>

<div>
    <label className="block font-semibold mb-1">
        City<span className="text-red-500">*</span>
    </label>
    <select
        name="city"
        value={formData.city}
        onChange={(e) => setFormData({ ...formData, city: e.target.value })}
        className="w-full border rounded p-2"
        required
    >
        <option value="">Select City</option>
        <option value="nil">Nil</option> {/* Added Nil option */}
        {cities.map((city) => (
            <option key={city.id} value={city.id}>
                {city.tamil}
            </option>
        ))}
    </select>
</div>



          <div>
            <label className="block font-semibold mb-1">Pincode<span className="text-red-500">*</span></label>
            <input
              type="text"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
              className="w-full border rounded p-2"
              required
            />
          </div>
          <div>
            <label className="block font-semibold mb-1">Other Details</label>
            <textarea
              name="otherDetails"
              value={formData.otherDetails}
              onChange={handleChange}
              className="w-full border rounded p-2"
            ></textarea>
          </div>
          <div>
            <label className="block font-semibold mb-1">Web Links</label>
            <input
              type="text"
              name="webLinks"
              value={formData.webLinks}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
          <div>
            <label className="block font-semibold mb-1">YouTube Links</label>
            <input
              type="text"
              name="youtubeLinks"
              value={formData.youtubeLinks}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
          <div>
            <label className="block font-semibold mb-1">Facebook Links</label>
            <input
              type="text"
              name="facebookLinks"
              value={formData.facebookLinks}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
          <div>
            <label className="block font-semibold mb-1">DND</label>
            <select
              name="dnd"
              value={formData.dnd}
              onChange={handleChange}
              className="w-full border rounded p-2"
            >
              <option value="">Show all</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>
         {/* File Uploads Section */}
         <div className="mt-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-9">
       
          </div>
        </div>
{/* Add other file upload fields in a similar manner */}
<div className="mt-6 flex justify-end">
  <button
    type="submit"
    className="bg-blue-600 text-white px-4 py-2 rounded"
  >
    Save
  </button>
</div>

      </form>
    </div>
  );
};

export default RegistrationForm;